interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const base = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return <script type="application/ld+json">{JSON.stringify(base)}</script>;
}